var map = {
	"./bg_about.png": "/8Ev",
	"./finished.png": "py91",
	"./logo.png": "Phjq",
	"./logo_white.png": "a9/k",
	"./navi-arrow.png": "pzWk",
	"./plex.png": "xR9k",
	"./updating.png": "mcMB",
	"./备案图标.png": "wCij"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "85ug";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home ^\.\/.*\.png$
// module id = 85ug
// module chunks = 1